import { lloFetch } from '../../../helpers/lloFetch';
import trans from '../../../helpers/trans';
import { FetchResult, FetchResultType } from '../../FetchResult';
import { SkillBaseResource, SkillResource } from './Skills';

export const getCompetentNLSkillsApiCall = async (query: string): Promise<FetchResult<SkillBaseResource[], string>> => {
    try {
        const requestConfig = new URLSearchParams({
            searchTerm: query,
            pageSize: '10',
            page: '1',
        }).toString();

        const skillsResponse = await lloFetch(`/api/competentNLSkill/Search?${requestConfig}`);

        if (!skillsResponse.ok) {
            return {
                status: skillsResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const skillsData = await skillsResponse.json();

        return {
            status: skillsResponse.status,
            type: FetchResultType.Success,
            data: skillsData.data as SkillBaseResource[],
        };
    } catch (error) {
        console.error('[getCompetentNLSkillsApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};

export const getCompetentNLSkillApiCall = async (id: string): Promise<FetchResult<SkillResource, string>> => {
    try {
        const skillResponse = await lloFetch(`/api/competentNLSkill/${id}`);

        if (!skillResponse.ok) {
            return {
                status: skillResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const skillData = await skillResponse.json();

        return {
            status: skillResponse.status,
            type: FetchResultType.Success,
            data: skillData as SkillResource,
        };
    } catch (error) {
        console.error('[getCompetentNLSkillApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
